<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>社区 - 行业交流与信息枢纽</h3>
				</div>
				<div class="info-content" v-html="infoText">
				</div>
			</div>
		</div>
	</el-main>
</template>

<script>
	export default {
        data() {
            return {
                infoText: `
                    <ul><li style="text-align: left; line-height: 2;">特规通不仅是一款工具，更致力于打造特种设备从业者的线上社区，促进业内交流互助。社区板块为用户提供了丰富的内容版块和互动渠道，让您在获取知识之余，也能掌握行业动态、参与讨论研讨、分享经验资源：</li><li style="text-align: left; line-height: 2;">行业新闻：汇总特种设备领域的重要资讯和最新动态。一站式浏览国家及各地监管部门发布的通知公告、新法规标准发布信息，了解行业前沿的新技术、新产品和应用案例，以及龙头企业动态、展会培训等活动预告。特规通社区每日更新权威信息，帮助您时刻走在行业前列。</li><li style="text-align: left; line-height: 2;">法规标准研讨：针对此行业高度关注的法规标准，社区提供研讨交流的平台。我们与标准编制机构合作发布标准征求意见稿，广大用户可在线阅读草案并提交反馈建议，共同参与标准制定完善。此外，对于已实施的重要标准和TSG规范，社区长期开放实施效果讨论专帖，收集一线从业人员的执行反馈，推动监管与标准的改进。您也可以自行围绕某个文件或议题创建讨论话题，就技术难题寻求同行和专家的解答。社区鼓励用户分享对法规条款的理解、执行经验或学习笔记，让宝贵的个人见解在行业内交流传承。</li><li style="text-align: left; line-height: 2;">资源供需发布：社区设置了类似公告板的供需信息栏目，涵盖人才和项目等各类信息发布。您可以在此发布或浏览招聘求职信息，发现合适的岗位或人才；发布项目合作或设备采购/出售需求，寻求商业机会和合作伙伴；甚至发布产品供应或二手设备交易信息，拓展业务渠道。特规通社区为行业资源对接搭建了便捷桥梁，帮助您更好地利用人脉和市场信息。</li><li style="text-align: left; line-height: 2;">通过社区板块，特种设备行业人员可以打破地域和单位壁垒，实现信息共享与合作共赢。在这里，您既是知识的获取者，也是经验的传播者。一个活跃互助的行业生态正在形成，特规通期待您的加入，共同建设一个专业、开放的特种设备交流平台！</li></ul>
                `
            }
        }
	};
</script>

<style lang="less" scoped>
	.info-wrap {
		margin-left: 20px;
		padding: 20px 0 !important;
		font-size: 14px;
		color: #475569;
		line-height: 1.8;
		background-color: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		border-radius: 12px;
		 min-height: calc(100vh - 120px);
		h3 {
			margin: 0 0 10px;
			font-weight: 600;
			font-size: 24px;
			color: #334155;
		}
	}
	.info-item {
		margin-bottom: 20px;
	}
	.info-head {
		margin-bottom: 25px;
		padding-bottom: 15px;
		border-bottom: 1px dashed #e2e8f0;
		.topbox {
			color: #94a3b8;
			dd {
				margin: 0 30px 0 0;
			}
		}
	}
</style>

<style lang="less">
.info-content {
		padding: 0 30px;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}


	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}

	.info-content li::marker {
		color: #1456f0;
	}
</style>